export default __webpack_public_path__ + "static/blogEightImage_featuredImage-8b0bcb94e93f9ce29c808b9c98257bd0.webp";